import React, {Component} from "react";
import {reduxForm} from "redux-form";
import {Modal} from "react-bootstrap";
import ModalHeader from "../ModalHeader";
import ModalBody from "../ModalBody";
import ModalFooter from "../ModalFooter";
import {connectModal} from "redux-modal";
import PropTypes from "prop-types";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ConfirmModificationField from "../../custom-fields/ConfirmModificationField";
import {cloneDeep} from "lodash";
import {
    editSowCycle,
    editSowCycleNotificationFailure,
    editSowCycleNotificationSuccess,
} from "../../../api/cycles/editSowCycle";

export const ModalName = "animal-remove-event-modal";

class AnimalRemoveEventModal extends Component {
    constructor(props) {
        super(props);
        const {handleHide, selectedEvent} = this.props;
        if (!selectedEvent) {
            handleHide();
        }
    }

    render() {
        const {
            show,
            handleHide,
            t,
            handleSubmit,
            submitting,
            selectedEvent,
            animal,
            invalid,
        } = this.props;

        return (
            <Modal
                onHide={handleHide}
                show={selectedEvent ? show : false}
                size={"lg"}>
                <form onSubmit={handleSubmit}>
                    <ModalHeader
                        title={t("animalDocuments.deleteEventTitle")}
                        onCloseClick={handleHide}
                    />
                    <ModalBody>
                        <p>
                            {t("animalDocuments.deleteEventMessageShort", {
                                AnmNo1: animal?.AnmNo1,
                            })}
                        </p>
                        <ConfirmModificationField
                            name={animal?.AnmNo1}
                            edit={false}
                        />
                    </ModalBody>
                    <ModalFooter
                        hasConfirmButton={true}
                        hasButtonDisabled={invalid}
                        confirmText={t("yes")}
                        closeText={t("cancel")}
                        onCloseClick={handleHide}
                        submitting={submitting}
                        formName={ModalName}
                    />
                </form>
            </Modal>
        );
    }
}

AnimalRemoveEventModal.propTypes = {
    selectedEvent: PropTypes.array.isRequired,
    animal: PropTypes.object.isRequired,
};

const submit = (values, dispatch, props) => {
    console.log(values, props);
    const events = cloneDeep(props.selectedEvent);
    if (values._Comment) {
        for (let item of events) {
            item._Comment = values._Comment;
        }
    }
    const data = {
        AnmID: props.animal.AnmID,
        eventsToUpdate: [],
        eventsToDelete: events,
    };
    return editSowCycle(data, {FarmID: events[0].FarmID})
        .then((res) => {
            editSowCycleNotificationSuccess(res);
            props.handleHide();
        })
        .catch((e) => {
            editSowCycleNotificationFailure(e);
        });
};

export default compose(
    connectModal({name: ModalName}),
    reduxForm({
        form: ModalName,
        onSubmit: submit,
    }),
    withTranslation()
)(AnimalRemoveEventModal);
